<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput
                    :options="valueInput.options"
                    :data="valueInput.data"
                  />
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput
                    :options="nameInput.options"
                    :data="nameInput.data"
                  />
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea
                    :options="descriptionInput.options"
                    :data="descriptionInput.data"
                    v-model="descriptionInput.data.model"
                  />
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-save"></i> Lưu lại
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import BaseTextArea from "../../base/BaseTextArea.vue";

export default {
  name: "AudioStationUpdate",
  components: {BaseInput, BaseLoading, BaseTextArea},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      wardCode: {value: null},
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id",
        },
      },
      valueInput: {
        options: {
          label: "Mã nhóm truyền thanh <span class='required'>*</span>",
          placeholder: "Mã nhóm truyền thanh",
          maxlength: 35,
          readonly: true
        },
        data: {
          name: "value",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.valueInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mã nhóm truyền thanh không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      nameInput: {
        options: {
          label: "Tên nhóm truyền thanh <span class='required'>*</span>",
          placeholder: "Tên nhóm truyền thanh",
          maxlength: 35,
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên nhóm truyền thanh không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      descriptionInput: {
        options: {
          label: "Mô tả",
          placeholder: "Mô tả",
          maxlength: 2000,
          rows: 5,
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
        },
      },
    };
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/audio-station/update",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật nhóm truyền thanh thành công",
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    loadData: function () {
      let that = this;
      that.loading.value = true;
      this.$helper.loadDataSource({
        loading: that.loading,
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        ignoreDefaultData: true,
        url: "/audio-station/findById",
        successCallback: function (response) {
          that.wardCode.value = response.data.data.wardCode;
          that.$helper.setupDataResponse(that.$data, response.data.data);
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        },
      });
    },
  },
  computed: {},
  created() {
    this.loadData();
  },
  mounted() {
  },
  watch: {},
};
</script>
